export default "__VITE_ASSET__DI7n6YxJ__"